function initAppScreenshotCarousels() {
  document.querySelectorAll("[data-app-screenshot-carousel]").forEach((carousel) => {
    if (carousel.dataset.appCarouselReady === "true") return;

    const rail = carousel.querySelector("[data-app-screenshot-rail]");
    const slides = Array.from(carousel.querySelectorAll(".app-screenshot"));
    const dots = Array.from(carousel.querySelectorAll("[data-app-screenshot-dot]"));

    if (!rail || !slides.length || dots.length !== slides.length) return;
    carousel.dataset.appCarouselReady = "true";

    const setActiveDot = (activeIndex) => {
      dots.forEach((dot, index) => {
        dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
      });
    };

    const getActiveIndex = () => {
      const firstSlideOffset = slides[0].offsetLeft;
      const railCenter = rail.scrollLeft + rail.clientWidth / 2;
      return slides.reduce((closestIndex, slide, index) => {
        const closestSlide = slides[closestIndex];
        const slideCenter = slide.offsetLeft - firstSlideOffset + slide.offsetWidth / 2;
        const closestCenter = closestSlide.offsetLeft - firstSlideOffset + closestSlide.offsetWidth / 2;
        return Math.abs(slideCenter - railCenter) < Math.abs(closestCenter - railCenter) ? index : closestIndex;
      }, 0);
    };

    let ticking = false;
    const syncDots = () => {
      ticking = false;
      setActiveDot(getActiveIndex());
    };

    rail.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncDots);
    }, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const firstSlideOffset = slides[0].offsetLeft;
        const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
        rail.scrollTo({ left: slides[index].offsetLeft - firstSlideOffset, behavior });
        setActiveDot(index);
      });
    });

    window.addEventListener("resize", syncDots);
    setActiveDot(getActiveIndex());
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAppScreenshotCarousels, { once: true });
} else {
  initAppScreenshotCarousels();
}
